import React from "react";

/* Card-shaped skeleton row. Replaces the full-page spinner so the loading
   state keeps the shape of the results it is standing in for. The shimmer and
   its reduced-motion opt-out live in tokens.css (.u1-sk). */
const SkeletonRow = () => (
  <div className="flex items-center gap-4 rounded-xl border border-[var(--line)] bg-white p-4 sm:p-5 opacity-90">
    <div className="u1-sk w-14 h-14 rounded-[14px] shrink-0" />
    <div className="flex-1 grid gap-[9px]">
      <div className="u1-sk h-[13px] w-[42%] rounded-md" />
      <div className="u1-sk h-[11px] w-[26%] rounded-md" />
    </div>
    <div className="u1-sk h-[26px] w-[88px] rounded-full shrink-0" />
  </div>
);

export const ResultSkeleton = ({ rows = 3 }) => (
  <div className="grid gap-3" role="status" aria-live="polite" aria-busy="true">
    <span className="sr-only">Searching the directory…</span>
    {Array.from({ length: rows }, (_, i) => (
      <SkeletonRow key={`sk-${i}`} />
    ))}
  </div>
);

export default ResultSkeleton;
